import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import React from 'react';
import { User } from '../Authentication';
import ExperienceCardContent from './ExperienceCardContent';
import PersonalInfoCardContent from './PersonalInfoCardContent';
import ResumeContentCard from './ResumeContentCard';
import SkillsContentCard from './SkillsContentCard';
import { EngineerWithSkills } from './useEngineerWithSkills';

interface Props {
  engineer: EngineerWithSkills;
  user: User
}

export default function ProfileDisplay({ engineer, user }: Props) {
  return (
    <div>
      <Card>
        <PersonalInfoCardContent info={user} />
        {engineer.experience && (
          <>
            <Divider />
            <ExperienceCardContent experience={engineer.experience} />
          </>
        )}
        <Divider />
        <SkillsContentCard skills={engineer.skills} />
        {Boolean(engineer.linkedIn || engineer.cv) && (
          <>
            <Divider />
            <ResumeContentCard engineer={engineer} />
          </>
        )}
      </Card>
    </div>
  );
}
